export var __prod__ = process.env.NODE_ENV === 'production';
/**
 * Базовые URL для GraphQL/REST (API) и публичного приложения (редиректы, ссылки).
 *
 * При сборке фронта (iomart-dashboard + Vite) подставляются из .env:
 * - production: REACT_APP_IOMART_PROD_API_URL, REACT_APP_IOMART_PROD_APP_URL
 * - development: REACT_APP_IOMART_DEV_API_URL, REACT_APP_IOMART_DEV_APP_URL
 *
 * Пример для отдельного стенда (etari) перед `npm run build` в дашборде:
 *   REACT_APP_IOMART_PROD_API_URL=https://api.etari.de
 *   REACT_APP_IOMART_PROD_APP_URL=https://crm.etari.de
 */
var DEFAULT_PROD_API = 'https://api.iomart.ru';
var DEFAULT_PROD_APP = 'https://app.iomart.ru';
var DEFAULT_DEV_API = 'http://localhost:3001';
var DEFAULT_DEV_APP = 'http://localhost:8080';
export var API_URL = __prod__
    ? process.env.REACT_APP_IOMART_PROD_API_URL || DEFAULT_PROD_API
    : process.env.REACT_APP_IOMART_DEV_API_URL || DEFAULT_DEV_API;
export var APP_URL = __prod__
    ? process.env.REACT_APP_IOMART_PROD_APP_URL || DEFAULT_PROD_APP
    : process.env.REACT_APP_IOMART_DEV_APP_URL || DEFAULT_DEV_APP;
